module.exports = __webpack_public_path__ + "img/bookmark.e4d81f5f.svg";